'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _createReducer;

exports.isAuthLoaded = isAuthLoaded;
exports.loadAuth = loadAuth;

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _reduxImmutablejs = require('redux-immutablejs');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_AUTH = 'karmapa-digital-toolbox/auth/LOAD_AUTH';
var LOAD_AUTH_SUCCESS = 'karmapa-digital-toolbox/auth/LOAD_AUTH_SUCCESS';
var LOAD_AUTH_FAIL = 'karmapa-digital-toolbox/auth/LOAD_AUTH_FAIL';

var initialState = _immutable2.default.Map({
  csrfToken: null,
  authLoaded: false
});

exports.default = (0, _reduxImmutablejs.createReducer)(initialState, (_createReducer = {}, (0, _defineProperty3.default)(_createReducer, LOAD_AUTH, function (state) {
  return state.set('loading', true);
}), (0, _defineProperty3.default)(_createReducer, LOAD_AUTH_SUCCESS, function (state, action) {
  var csrfToken = action.result.csrfToken;

  return state.set('loading', false).set('authLoaded', true).set('csrfToken', csrfToken);
}), (0, _defineProperty3.default)(_createReducer, LOAD_AUTH_FAIL, function (state, action) {
  return state.set('loading', false).set('authLoaded', false).set('authError', action.error);
}), _createReducer));
function isAuthLoaded(globalState) {
  return globalState.auth && globalState.auth.get('authLoaded');
}

function loadAuth() {
  return {
    types: [LOAD_AUTH, LOAD_AUTH_SUCCESS, LOAD_AUTH_FAIL],
    promise: function promise(client) {
      return client.get('/auth');
    }
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/auth.js
 ** module id = 546
 ** module chunks = 0
 **/